import { SitkaModule } from "olio-sitka"
import { call, put, select } from "redux-saga/effects"
import { webhookSubscriptionArrayToModuleState } from "../../util/webhook_subscriptions_utils"

export default class WebhookSubscriptionsModule extends SitkaModule {
    moduleName = "webhookSubscriptions"
    defaultState = {
        items: {},
        sort: [],
    }

    constructor() {
        super()
        this.updateState = this.updateState.bind(this)
    }

    *handleIngressWebhookSubscriptions(webhookSubscriptionArray) {
        const state = webhookSubscriptionArrayToModuleState(
            webhookSubscriptionArray,
        )

        yield call(this.updateState, { ...state })
    }

    *handleClearWebhookSubscriptions() {
        yield call(this.updateState, { ...this.defaultState })
    }

    *updateState(newState) {
        yield put(
            this.setState({
                ...(yield select(this.getCurrentState)),
                ...newState,
            }),
        )
    }

    getCurrentState(state) {
        return state.WebhookSubscription
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/webhook_subscriptions.js